// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appDisplayName: "PATIENT CENTRAL",
  // appApiUrl: "https://localhost:5001/v1/",
  appApiUrl: "https://api.patientcentral.io/v1/",
  defaultCredentials: {
    email: "",
    password: "",
  },
  storageType: "localStorage", // Could be either 'localStorage' or 'sessionStorage'
  idleDuration: 99999, // idle in seconds before automatic log out
  loginPagePath: "login-alt", // path (from app-routing module) of the login page
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
